
import { mapState } from 'vuex';
import servicesMixin from '~/mixins/services';
import vanSizesMixin from '~/mixins/vanSizes';

export default {
    name: 'WasteRemovalServiceForm',
    mixins: [servicesMixin, vanSizesMixin],
    props: {
        form: {
            type: Object,
            required: true,
        },
        isEditForm: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showBigger: false,
        };
    },
    async fetch() {
        await this.$store.dispatch('services/get');
        if (this.$route.query.service) {
            if (this.$route.query.size && this.$route.query.service === 1) {
                const size = this.vanSizes.find((s) => s.slug === this.$route.query.size);
                this.selectService(size, true);
                return;
            }
            const id = parseInt(this.$route.query.service, 10);
            const service = this.services.data.find((s) => s.id === id);
            if (service && service.id !== 1) {
                this.selectService(service, true);
            }
        }
    },
    computed: {
        ...mapState(['services', 'isMobile']),
        manAndVan() {
            return this.vanSizes;
        },
        returnManAndVan() {
            return this.showBigger ? this.manAndVan : this.manAndVan.slice(0, 4);
        },
        otherServices() {
            return [...this.servicesWithIcons].filter((service) => service.id !== 1);
        },
    },
    mounted() {
        if (this.form.size.$model === '3_4' || this.form.size.$model === 'full') {
            this.showBigger = true;
        }
    },
    methods: {
        selectService(service, replaceRoute = false) {
            /* eslint vue/no-mutating-props: 0 */
            // @todo fix this
            this.form.size.$model = service.id !== 1 ? '' : service.slug;
            this.form.services.$model = service.id;
            // Wait for value of services to change upstream and adjust steps before continuing
            this.$nextTick(() => this.$emit('submit', replaceRoute));
        },
    },
};
